// Online/offline indicator hook — V1 parity.
// V1 wires window online/offline to updateSyncUI (public/app/index.html L5587–5592,
// L19123–19127). V2 shows toasts via the toast store so the banner composes with
// other notifications.

import { useEffect, useRef, useState } from 'react'

export interface OnlineStatus {
  online: boolean
  /** True once an online→offline or offline→online transition has occurred. */
  hasChanged: boolean
}

export function useOnlineStatus(): OnlineStatus {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  )
  const changedRef = useRef(false)

  useEffect(() => {
    function onOnline() {
      changedRef.current = true
      setOnline(true)
    }
    function onOffline() {
      changedRef.current = true
      setOnline(false)
    }
    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)
    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  return { online, hasChanged: changedRef.current }
}
